import { render } from "./User_Profile.vue?vue&type=template&id=f20a94de&scoped=true"
import script from "./User_Profile.vue?vue&type=script&lang=js"
export * from "./User_Profile.vue?vue&type=script&lang=js"

import "./User_Profile.vue?vue&type=style&index=0&id=f20a94de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f20a94de"]])

export default __exports__